import type { JobType, ProductionJobSummary, ProductionStatus } from '../types';

export const ALLOWED_PRODUCTION_LANE_JOB_TYPES: ReadonlyArray<JobType> = ['ga', 'gap', 'gc'];

export const PRODUCTION_LANE_MOVE_BLOCKED_MESSAGE =
  'Only Glass Arrival, Glass Cutting, and Glass Processing jobs (not quotation orders) can move to In Production or Problem Orders.';

export const UNCLASSIFIED_IN_PRODUCTION_MESSAGE =
  'This job has no Glass Arrival, Glass Cutting, or Glass Processing classification. Assign glass values on the job orders before moving to In Production.';

export const QUOTATION_IN_PRODUCTION_MESSAGE =
  'Quotation orders cannot move to In Production.';

export function isUnclassifiedJob(job: Pick<ProductionJobSummary, 'job_type'>): boolean {
  return !job.job_type || !ALLOWED_PRODUCTION_LANE_JOB_TYPES.includes(job.job_type);
}

export function isInProductionMoveBlocked(
  job: ProductionJobSummary,
  targetStatus: ProductionStatus
): boolean {
  if (targetStatus !== 'in_production') return false;
  if (job.has_quotation_product === true) return true;
  return isUnclassifiedJob(job);
}

/** GA / GAP / GC only; quotation jobs cannot move to Problem Orders (and lane moves generally). */
export function isProductionLaneMoveBlocked(
  job: ProductionJobSummary,
  targetStatus: ProductionStatus
): boolean {
  if (targetStatus !== 'in_production' && targetStatus !== 'problem_orders') {
    return false;
  }
  if (job.has_quotation_product === true) return true;
  if (isUnclassifiedJob(job)) return true;
  return false;
}

export function getProductionMoveBlockedMessage(
  job: ProductionJobSummary,
  targetStatus: ProductionStatus
): string {
  if (targetStatus === 'in_production') {
    if (job.has_quotation_product === true) {
      return QUOTATION_IN_PRODUCTION_MESSAGE;
    }
    if (isUnclassifiedJob(job)) {
      return UNCLASSIFIED_IN_PRODUCTION_MESSAGE;
    }
  }
  return PRODUCTION_LANE_MOVE_BLOCKED_MESSAGE;
}

export function shouldShowUnclassifiedBadge(job: ProductionJobSummary): boolean {
  return (
    job.production_status === 'new_orders' &&
    isUnclassifiedJob(job) &&
    job.has_quotation_product !== true
  );
}
